// extracted by mini-css-extract-plugin
export var box = "_16-2";
export var checkboxControl = "_16-0";
export var checkboxRow = "_16-a";
export var checked = "_16-3";
export var descriptionSpacer = "_16-c";
export var disabled = "_16-4";
export var icon = "_16-8";
export var input = "_16-1";
export var labelSpacer = "_16-b";
export var large = "_16-7";
export var medium = "_16-6";
export var small = "_16-5";
export var text = "_16-9";